// shown in the journey form when no option has a price matching the product date
// (the backend matches the option prices on the date's period, country and duration)
export const getNoThemeAvailableMessage = (periodName?: string) =>
  periodName
    ? `Aucun thème n'a de prix pour la période ${periodName} : ajoutez un prix d'option pour cette période, le pays et la durée de cette date dans Thèmes et options.`
    : `Aucun thème n'a de prix pour cette date : ajoutez un prix d'option pour le pays et la durée de cette date dans Thèmes et options.`
